module.exports = __webpack_public_path__ + "static/media/play-player.2c97feae.png";